import React from "react";

export default function BeforeSellingPointsSection({
  title,
  description,
  points = [],
  closingText,
}) {
  if (!title || points.length === 0) return null;

  const renderTitle = () => {
    if (title.includes("Rajajinagar")) {
      return (
        <>
          Before Selling Gold in{" "}
          <span className="text-[#d7a51f]">Rajajinagar</span>, Check These
          Points
        </>
      );
    }

    return title;
  };

  return (
    <section className="relative overflow-hidden bg-[#fff8e8] py-14 sm:py-16 lg:py-24">
      {/* Premium cream background */}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.95),transparent_30%),radial-gradient(circle_at_bottom_right,rgba(215,165,31,0.14),transparent_36%)]" />
      <div className="pointer-events-none absolute left-[-220px] top-[-180px] h-[520px] w-[520px] rounded-full bg-[#f2d36a]/18 blur-3xl" />
      <div className="pointer-events-none absolute right-[-260px] bottom-[-240px] h-[620px] w-[620px] rounded-full bg-[#d7a51f]/12 blur-3xl" />

      <div className="relative mx-auto max-w-[1280px] px-5 sm:px-6 lg:px-10">
        {/* Heading */}
        <div className="mx-auto max-w-[980px] text-center">
          <div className="mx-auto mb-5 flex w-[190px] items-center justify-center gap-4">
            <span className="h-px flex-1 bg-gradient-to-r from-transparent to-[#d7a51f]" />
            <span className="h-2.5 w-2.5 rotate-45 bg-[#d7a51f]" />
            <span className="h-px flex-1 bg-gradient-to-r from-[#d7a51f] to-transparent" />
          </div>

          <h2 className="font-serif text-[30px] font-extrabold leading-tight tracking-[-0.02em] text-[#071426] sm:text-[42px] lg:text-[54px]">
            {renderTitle()}
          </h2>

          {description && (
            <p className="mx-auto mt-5 max-w-[780px] text-[16px] font-medium leading-8 text-[#334155] sm:text-[18px]">
              {description}
            </p>
          )}
        </div>

        {/* Desktop Table */}
        <div className="mx-auto mt-12 hidden max-w-[1080px] overflow-hidden rounded-[28px] border border-[#ead8a8] bg-white shadow-[0_28px_90px_rgba(20,33,61,0.10)] md:block">
          <table className="w-full border-collapse">
            <thead>
              <tr>
                <th className="w-[42%] border-r border-[#ead8a8] bg-white px-8 py-6 text-left text-[22px] font-extrabold text-[#071426]">
                  What to Check
                </th>

                <th className="w-[58%] bg-gradient-to-r from-[#c69208] via-[#d7a51f] to-[#e5b72c] px-8 py-6 text-left text-[22px] font-extrabold text-white">
                  Why It Matters
                </th>
              </tr>
            </thead>

            <tbody>
              {points.map((point, index) => (
                <tr key={index} className="border-t border-[#ead8a8]">
                  <td className="border-r border-[#ead8a8] bg-white px-8 py-7 text-[19px] font-extrabold leading-8 text-[#071426]">
                    {point.check}
                  </td>

                  <td className="bg-[#fff8e8] px-8 py-7 text-[18px] font-medium leading-8 text-[#071426]">
                    {point.reason}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Table */}
        <div className="mx-auto mt-10 max-w-[720px] overflow-hidden rounded-[24px] border border-[#ead8a8] bg-white shadow-[0_24px_70px_rgba(20,33,61,0.10)] md:hidden">
          <div className="grid grid-cols-2">
            <div className="border-b border-r border-[#ead8a8] bg-white px-4 py-4 text-[15px] font-extrabold text-[#071426]">
              What to Check
            </div>

            <div className="border-b border-[#ead8a8] bg-gradient-to-r from-[#c69208] via-[#d7a51f] to-[#e5b72c] px-4 py-4 text-[15px] font-extrabold text-white">
              Why It Matters
            </div>
          </div>

          {points.map((point, index) => (
            <div
              key={index}
              className="grid grid-cols-2 border-b border-[#ead8a8] last:border-b-0"
            >
              <div className="border-r border-[#ead8a8] bg-white px-4 py-4 text-[15px] font-extrabold leading-7 text-[#071426]">
                {point.check}
              </div>

              <div className="bg-[#fff8e8] px-4 py-4 text-[15px] font-medium leading-7 text-[#071426]">
                {point.reason}
              </div>
            </div>
          ))}
        </div>

{/* Closing Text */}
{closingText && (
  <div className="mx-auto mt-10 max-w-[1080px] overflow-hidden rounded-[22px] bg-[#d7a51f] px-6 py-6 shadow-[0_22px_70px_rgba(215,165,31,0.18)]">
    <p className="text-[17px] font-extrabold leading-8 text-white sm:text-[19px]">
      {closingText}
    </p>
  </div>
)}
      </div>
    </section>
  );
}